import React from 'react';
import { FaUsers, FaHandshake, FaBalanceScale, FaPhone } from 'react-icons/fa';

const UseCasesSection = () => {
  return (
    <>
      {/* Use Cases Section start */}
      <div className="service-area pd-top-100 pd-bottom-100">
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">CASOS DE USO</h6>
            <h2 className="title">
              Perfecto para cualquier <span>industria</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="single-service-inner">
                <div className="thumb mb-3">
                  <FaUsers size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">RR.HH.</h5>
                  <p>
                    Contratos de trabajo, anexos, finiquitos, consentimientos.
                    Acelera tus procesos de contratación y gestión de personal.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="single-service-inner">
                <div className="thumb mb-3">
                  <FaHandshake size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">Comercial</h5>
                  <p>
                    Órdenes de compra, propuestas, acuerdos de servicio.
                    Cierra tratos más rápido y sin papeleos.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="single-service-inner">
                <div className="thumb mb-3">
                  <FaBalanceScale size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">Legal</h5>
                  <p>
                    NDAs, contratos de arriendo, poderes simples.
                    Documentos legales con total trazabilidad.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-4">
              <div className="single-service-inner">
                <div className="thumb mb-3">
                  <FaPhone size={48} className="text-primary" />
                </div>
                <div className="details">
                  <h5 className="mb-3">Atención al cliente</h5>
                  <p>
                    Autorizaciones y consentimientos informados.
                    Mejora la experiencia de tus clientes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Use Cases Section end */}
    </>
  );
};

export default UseCasesSection;
